<template>
  <Dialog
      :header="t('REMOVE_PERSON_FROM_GROUP', { name: removeTraineeModalData.trainee?.fullName })"
      v-model:visible="visible"
      modal
      class="remove-trainee-modal overflow-hidden"
      :draggable="false"
      :dismissable-mask="true"
      @hide="resetRemoveModal"
  >
    <form ref="removeReasonFormRef" @submit.prevent="handleRemoveModalSubmit">
      <div class="mb-2">
        <label class="form-label" for="remove-trainee-reason">{{ t('REASON') }}</label>
        <Select
            v-model="removeTraineeModalData.type"
            :options="reasonTypes"
            id="remove-trainee-reason"
            option-label="label"
            option-value="value"
            :placeholder="t('SELECT')"
            class="w-100"
        />
      </div>

      <div v-if="removeTraineeModalData.type === 'GROUP_REMOVE_OTHER'" class="mb-2">
        <label class="form-label" for="remove-trainee-note">{{ t('NOTE') }}</label>
        <Textarea
            v-model="removeTraineeModalData.reason"
            required
            id="remove-trainee-note"
            class="w-100"
            rows="3"
        />
      </div>
    </form>

    <confirm-overlay
        :show="showConfirm"
        :text="'REMOVE_PERSON_FROM_GROUP_CONFIRM'"
        v-on:yes="handleConfirmOk"
        v-on:no="handleConfirmCancel"
    />

    <template #footer>
      <Button :label="t('CANCEL')" severity="secondary" @click="visible = false"/>
      <Button
          :label="t('REMOVE')"
          severity="danger"
          :disabled="
            removeTraineeModalData.type !== 'GROUP_REMOVE_ELIGIBILITY' &&
            !removeTraineeModalData.reason
          "
          @click="handleRemoveModalOk"
      />
    </template>
  </Dialog>
</template>

<script setup>
import EventBus from "@/util/eventBus";
import ConfirmOverlay from "@/views/components/modals/confirmOverlay.vue";
import {useI18n} from "vue-i18n";
import {computed, onBeforeUnmount, onMounted, ref} from "vue";

const {t} = useI18n();
const visible = ref(false);
const removeReasonFormRef = ref(null);
const removeTraineeModalData = ref({
  trainee: null,
  reason: null,
  type: null,
});

const showConfirm = ref(false);
const emit = defineEmits(["remove-trainee", "no", "yes"]);

onMounted(() => {
  EventBus.$on("show-remove-trainee-modal", showRemoveTraineeModal);
});

onBeforeUnmount(() => {
  EventBus.$off("show-remove-trainee-modal", showRemoveTraineeModal);
});

const reasonTypes = computed(() => [
  {value: "GROUP_REMOVE_ELIGIBILITY", label: t("NOT_ELIGIBLE")},
  {value: "GROUP_REMOVE_OTHER", label: t("OTHER")},
]);

function resetRemoveModal() {
  removeTraineeModalData.value = {
    trainee: null,
    reason: "",
    type: "",
  };

  showConfirm.value = false;
}

function showRemoveTraineeModal(trainee) {
  visible.value = true;
  removeTraineeModalData.value.trainee = trainee;
}

function handleRemoveModalOk(ev) {
  ev.preventDefault();
  handleRemoveModalSubmit();
}

function handleRemoveModalSubmit() {
  if (!removeReasonFormRef.value?.reportValidity()) {
    return;
  }

  showConfirm.value = true;
}

function handleConfirmCancel() {
  showConfirm.value = false;
}

function handleConfirmOk() {
  emit("remove-trainee", removeTraineeModalData.value);
  visible.value = false;
}
</script>
